module.exports = __webpack_public_path__ + "img/Manuel-16.32c9be9d.jpg";